function toggleResponsiveMenu(){
	$(".contentWrapper").toggleClass("menu");
	var _collapse = $(".collapseMenu");
	
	if(_collapse.hasClass("open")){
		window.setTimeout(function(){
			_collapse.removeClass("open");
		},500);
	}
	else{
		_collapse.addClass("open");
	}
}